import classNames from "classnames"
import PropTypes from "prop-types"
import React, { Fragment } from "react"
import AllDeals from "src/main/DockwaPlusDeals/Marketing/AllDeals"
import DealSwimlane from "src/main/DockwaPlusDeals/Marketing/DealSwimlane"
import DockwaPlusDealsBanner from "src/main/DockwaPlusDeals/Marketing/DockwaPlusDealsBanner"

import HeadingModalTitle from "src/components/Heading/HeadingModalTitle"

import {
  queryFavorites,
  queryFuelDeals,
} from "src/api/DockwaPlusDeals/Marketing"

import useWindowSize from "src/hooks/use_window_size"

const DockwaPlusDealsMarketing = ({
  currentUserFirstName,
  hasActiveDockwaPlusSubscription,
  isSignedIn,
  dockageDeals,
}) => {
  const { isLargeScreen } = useWindowSize()

  const renderDeals = () => {
    return (
      <div className="flex flex-col space-y-6 py-6 pl-4 lg:pl-0">
        <Fragment>
          {isSignedIn && (
            <DealSwimlane
              hasActiveDockwaPlusSubscription={hasActiveDockwaPlusSubscription}
              title="Deals at your saved marinas"
              subtitle="Marinas you’ve saved or booked at in the past"
              primaryCta={{
                href: "/dockwa_deals/favorite_marinas",
                text: "View all",
              }}
              query={queryFavorites}
              queryKey="dealsAtFavorites"
            />
          )}
          <DealSwimlane
            hasActiveDockwaPlusSubscription={hasActiveDockwaPlusSubscription}
            title="Fuel Discounts"
            subtitle="Check out these great discounts on fuel"
            primaryCta={{
              href: "/dockwa_plus/fuel_discounts",
              text: "View all",
            }}
            secondaryCta={{
              href: "/search?dockwa_plus_fuel_discount",
              text: "View all on map",
            }}
            query={queryFuelDeals}
            queryKey="allFuelDeals"
            variant="fuel"
            eventBadgeProps={{
              mode: "time",
              hideAt: new Date("11/1/2025"),
            }}
          />
        </Fragment>
        <div className="flex flex-col space-y-4 pr-4 lg:pr-0">
          <div className="flex w-full flex-col space-y-2 lg:flex-row lg:items-center lg:justify-between lg:space-y-0">
            <div className="flex flex-col space-y-2">
              <HeadingModalTitle>All deals</HeadingModalTitle>
              <span className="text-gray-600">
                All active and upcoming dockwa+ deals
              </span>
            </div>
            <a
              href="/search?dockwa_plus_deal"
              className={classNames({
                "font-semibold text-blue-700": !isLargeScreen,
                "btn btn-tertiary": isLargeScreen,
              })}
            >
              View all on map
            </a>
          </div>
          <AllDeals
            deals={dockageDeals}
            hasActiveDockwaPlusSubscription={hasActiveDockwaPlusSubscription}
            variant="reservation"
          />
        </div>
      </div>
    )
  }
  return (
    <div className="-mt-6 lg:m-auto lg:max-w-[1248px] lg:p-4">
      <DockwaPlusDealsBanner
        currentUserFirstName={currentUserFirstName}
        hasActiveDockwaPlusSubscription={hasActiveDockwaPlusSubscription}
      />
      {renderDeals()}
    </div>
  )
}

DockwaPlusDealsMarketing.propTypes = {
  currentUserFirstName: PropTypes.string,
  hasActiveDockwaPlusSubscription: PropTypes.bool.isRequired,
  isSignedIn: PropTypes.bool.isRequired,
  dockageDeals: PropTypes.array.isRequired,
}

export default DockwaPlusDealsMarketing
